import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend'
import CookieManager from './lib/CookiesManager'

const hasFunctionalConsent = CookieManager.getConsent().functional

i18n
  .use(initReactI18next)
  .use(HttpBackend)
  .use(LanguageDetector)
  .init({
    backend: {
      loadPath: '/translations/{{lng}}/{{lng}}.json',
    } as HttpBackendOptions,
    debug: false,
    fallbackLng: 'fr-BE',
    supportedLngs: [
      'fr-BE',
      'nl-BE',
      'en-US',
      'es-ES',
      'de-DE',
      'it-IT',
      'pt-PT',
    ],
    returnObjects: true,
    detection: {
      caches: hasFunctionalConsent ? ['cookie'] : [],
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupCookie: 'i18next',
      cookieMinutes: 43200, // 30 jours
      cookieDomain: window.location.hostname,
      cookieOptions: {
        path: '/',
        sameSite: 'strict',
        secure: true,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  })

i18n.on('languageChanged', lng => {
  if (hasFunctionalConsent) {
    CookieManager.setLanguage(lng)
  }
})

if (!i18n.language) {
  i18n.changeLanguage(CookieManager.getLanguage() || 'fr-BE')
}

export default i18n
